// removed by extract-text-webpack-plugin
module.exports = {"answerBox":"SelectionButton__answerBox___h6jZXfj","selectionWrapper":"SelectionButton__selectionWrapper___2CebQZu","selectBtn":"SelectionButton__selectBtn___1IhdpDj"};